/**
 * Read a file as base64 string
 * @param {File} file - The file object to read
 * @returns {Promise<string>} A promise that resolves to the base64 data
 */
export const readFileAsBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      // Format: "data:[mime/type];base64,PHN2ZyB4bWxucz..."
      const resultStr = reader.result?.toString() || '';
      const base64 = resultStr.split(',')[1];
      resolve(base64);
    };
    reader.onerror = (err) => reject(err);
    reader.readAsDataURL(file);
  });
};

/**
 * Create an HTML template for payment message
 * @param {string} amount - Payment amount
 * @param {string} description - Payment description
 * @param {string} link - Optional payment link
 * @returns {string} HTML string for the payment message
 */
export const createPaymentMessage = (amount, description, link) => {
  return `
    <div style="padding: 16px; border-radius: 8px; margin: 8px 0;">
      <div style="display: flex; align-items: center; margin-bottom: 16px; color: #65B2EC;">
        <span style="font-size: 20px; margin-right: 8px;">💰</span>
        <span style="font-size: 16px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: bold;">PAYMENT REQUEST</span>
      </div>
      
      <div style="margin: 12px 0; display: flex; align-items: center;">
        <span style="font-weight: bold; width: 100px;">Amount:</span>
        <span style="font-size: 18px; color: #2ecc71; font-weight: bold;">$${amount}</span>
      </div>
      
      <div style="margin: 12px 0;">
        <div style="font-weight: bold; margin-bottom: 6px;">Description:</div>
        <div style="background: rgba(255,255,255,0.05); padding: 10px; border-radius: 6px; white-space: pre-wrap;">${description}</div>
      </div>
      
      ${link ? `
        <div style="margin: 12px 0;">
          <div style="font-weight: bold; margin-bottom: 6px;">Payment Link:</div>
          <a 
            href="javascript:void(0)" 
            class="payment-link" 
            data-payment-link="${link}"
            style="display: inline-block; background: #2980b9; color: white; padding: 8px 16px; border-radius: 4px; text-decoration: none; font-weight: bold;"
          >Click to Pay</a>
        </div>
      ` : ''}
    </div>
  `;
};

export default {
  readFileAsBase64,
  createPaymentMessage
}; 